import SelectIconPopup from "./SelectIconPopup";
import { jsx as _jsx } from "react/jsx-runtime";
export default function initializeSelectIcon(selectIcon, prevId) {
  var popupEvent = new CustomEvent("openPopup", {
    detail: {
      prevId: prevId,
      C: function C() {
        return /*#__PURE__*/_jsx(SelectIconPopup, {
          selectIcon: selectIcon
        });
      }
    }
  });
  window.dispatchEvent(popupEvent);
}